module.exports = __webpack_public_path__ + "static/media/folder.6393b4a4.svg";